export enum Colors {
  Red = 'rgb(255,0,0)',
  Orange = 'rgb(255,165,0)',
}

export const HexColors = {
  neutral: {
    1: '#1B1B1B',
  },
  green: {
    4: '#4CAF50',
  },
  red: {
    1: '#7B0000',
    4: '#FF5252',
  },
  blue: {
    4: '#006AF5',
  },
  orange: {
    1: '#F7A246',
  },
} as const;
